<template>
  <div class="landin_frame lan_flex">
    <section class="lan_header">
      <div class="lan_title">
        オンラインパチンコ/パチスロなら{{ brandName }} <br>
        最新&高還元機種一覧
      </div>

      <div class="gamesSearchBar">
        <div class="filter-a" @click="showSearchGame()">
          <input id="" type="text" class="gamesSearchInput" placeholder="検索">
        </div>
        <div class="filter-b" @click="showSearchProvider()">
          <i class="icon-filter"><img :src="$getThemeImagePath('icon-filter.png')" alt=""></i>
          <span class="txt">絞り込み</span>
        </div>
      </div>

      <div class="gamesTabFrame landingTab">
        <div v-for="(item, key) in gameCategory" :key="'game_' + key" class="tab" @click="changeGameCategory(item)">
          <a>{{ item.name }} </a>
        </div>
      </div>
    </section>

    <div class="tabs-content landingTabContent">
      <div id="tab00" class="tab-inner" style="">
        <div class="game-card-list game-type">
          <div
            v-for="game in allGameData"
            :key="game.id"
            class="game-card game-type"
            :class="{ active: activeGameId === game.id }"
            @mouseenter="activeGameId = game.id"
            @mouseleave="activeGameId = null"
          >
            <div v-if="game.brand_game_category_id.includes('HOT')" class="game-info-icon-hot">
              HOT
            </div>
            <div v-if="game.brand_game_category_id.includes('NEW')" class="game-info-icon-new">
              NEW
            </div>

            <div class="game-card-name">
              <div class="game-tx">
                <div class="game-name name-tex">
                  {{ game.name }}
                </div>
                <div class="game-provider-tx">
                  {{ game.game_provider_name }}
                </div>
                <span class="game-rtp">
                  <template v-if="game.rtp !== -1">
                    <p>RTP：</p>
                    <p>{{ (game.rtp * 100).toFixed(2) }}%</p>
                  </template>
                </span>
                <span class="game-provider">
                  <img :src="getProviderImage(game.game_provider_id)" alt="">
                </span>
              </div>
              <div class="game-info">
                <i class="game-info-icon" />
              </div>
            </div>
            <div class="game-card-image">
              <div class="img-mask" />
              <d-img :src="game" :alt="game.name" />
            </div>

            <div class="game-card-info">
              <div class="like">
                <i class="game-info-icon-heart active" :class="{ active: isGameFavorite(game.id) }" />
                <i class="game-info-icon-nobonus" />
              </div>
              <span>RTP：</span><span> <p>{{ (game.rtp * 100).toFixed(2) }}%</p></span>

              <div class="game-info-bn">
                <button @click.stop="handleLaunchGame(game)">
                  今すぐ遊ぶ
                </button>
                <button @click.stop="handleLaunchGame(game)">
                  お試しください
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="lanSection justify-content-center">
      <button class="btn btn-primary btn-landing" type="button" @click="loadMoreGames">
        さらに表示
      </button>
    </section>

    <section class="lanSection lanContentBox bg-white">
      <div class="lan_title">
        {{ brandName }}のオンラインパチンコ/パチスロの特徴
      </div>

      <div class="lanContent">
        <h4 class="lanSubtitle">
          特徴1: パチスロファン納得のラインナップ！
        </h4>
        <p>
          {{ brandName }}では懐かしの4号機や5号機といった名機から刺激的な裏物まで、多彩なラインナップを取り揃えています。常に新しいゲーム体験を提供しているので、飽きることなくお楽しみいただけます。パチスロファンの方もきっとご満足いただけます！
        </p>

        <br><br>

        <h4 class="lanSubtitle">
          特徴2: 24時間いつでもプレイ可能！
        </h4>
        <p>
          深夜でも早朝でも、お好きな時間にプレイできます。ホールまでわざわざ足を運ぶ必要もなく、ご自宅でリラックスしながらリアルなパチンコ・パチスロ体験を楽しめます。忙しい方でもスキマ時間を活用して気軽に遊べるのも魅力です。
        </p>

        <br><br>

        <h4 class="lanSubtitle">
          特徴3: スマホ・PCで快適に楽しめる！
        </h4>
        <p>
          専用アプリのダウンロードは不要です！スマートフォン、タブレット、PCなど、あらゆるデバイスから快適にアクセスできます。操作性にも優れているため、いつでもどこでもスムーズなプレイが可能です。初心者の方にもわかりやすい設計です。
        </p>
      </div>
    </section>

    <section class="lanSection lanContentBox bg-white">
      <div class="lan_title">
        {{ brandName }}のオンラインパチンコ/パチスロの始め方
      </div>

      <div class="lanStepBox">
        <div class="stepCube">
          <div class="stepNum">
            1
          </div>
          <div class="stepSub text-center">
            無料会員登録
          </div>
        </div>

        <div class="stepContent">
          <p>
            まずは{{ brandName }}での会員登録を行います。<br>
            「公式サイトが見つからない」「間違って別のサービスに登録した」という声も聞かれるので注意しておきましょう！
            会員登録に必要な物は「メールアドレス」「名前」「生年月日」「携帯電話番号」「住所」となっております。<br>
            これら情報が必要な理由は{{ brandName }}はリアルマネーを扱うため、20歳以上であることを確認したり所在国・所在地をしっかり確認する必要があるんですね。<br>
            登録時、特に迷うことも無いと思いますが心配な方は以下の記事を参考にしてください！
          </p>
        </div>
      </div>

      <div class="lanStepBox">
        <div class="stepCube">
          <div class="stepNum">
            2
          </div>
          <div class="stepSub text-center">
            <span class="txtPart">本人認証</span> 入金手続き
          </div>
        </div>

        <div class="stepContent">
          <p>{{ brandName }}で遊ぶためにはプレイ資金を入金する必要があります。</p>
          <br>

          <p>{{ brandName }}の入金方法一覧</p>

          <ul class="list-disc">
            <li>銀行送金</li>
            <li>VegaWallet</li>
            <li>仮想通貨</li>
            <li>JetonPay</li>
            <li>Match Pay</li>
          </ul>
          <br>
          <p>
            以上の入金方法から自分が一番やりやすい方法での入金を行いましょう。<br>
            また{{ brandName }}では「本人認証」をすることで入金できる金額が大きくなったり、出金ができるようになります。<br>
            はやめに本人認証＝アカウント認証を済ませておいた方が便利ですので、認証に必要な「免許証などの身分証明書」「住民票などの住所確認書類」「顔写真」などの情報を確認しておきましょう。
          </p>
        </div>
      </div>

      <div class="lanStepBox">
        <div class="stepCube">
          <div class="stepNum">
            3
          </div>
          <div class="stepSub text-center">
            機種を選ぶ
          </div>
        </div>

        <div class="stepContent">
          <p>
            会員登録と入金作業が終わればオンパチ・オンスロのプレイが可能になります。ログイン後の{{ brandName }}上部メニューから【パチンコ&パチスロ】を選択して、好きな機種を選びましょう。
            機種名や種類で検索・絞り込みもできます。
          </p>
        </div>
      </div>
    </section>

    <section class="lanSection lanContentBox bg-brown-02">
      <div class="lan_title">
        無料登録して新規登録特典をGET！
      </div>

      <div class="lanBTNFrame">
        <button class="btn btn-primary btn-landing" @click.stop="goHomeRegister">
          今すぐ登録
        </button>
      </div>
    </section>

    <section class="lanSection lanContentBox bg-white">
      <div class="lan_title">
        {{ brandName }}のオンラインパチンコ/パチスロの ボーナス＆キャンペーン情報
      </div>

      <div class="lanEvents">
        <div
          v-for="item in brandImage"
          :key="item.id"
          class="lanEventsBox"
        >
          <a
            class="eventPic"
            @click.prevent="handleClick(item.link,item.open_type)"
          >
            <img :src="item.image" alt="">
          </a>
        </div>
      </div>
    </section>

    <section class="lanSection lanContentBox bg-white">
      <div class="lan_title">
        よくある質問（FAQ）
      </div>

      <div class="lanContent">
        <h4 class="lanSubtitle">
          Q. 勝winへの登録方法はどうすればいいですか？
        </h4>

        <p class="QaTxt">
          「新規登録」をクリックし、必要事項を記入したら、登録完了となります。
        </p>

        <br><br>

        <h4 class="lanSubtitle">
          Q. どのようなデバイスでプレイできますか？
        </h4>

        <p class="QaTxt">
          勝winは、すべての携帯デバイスとデスクトップに対応しており、いつでもどこでもエンターテイメントを楽しんでいただけます。
        </p>

        <br><br>

        <h4 class="lanSubtitle">
          Q. 実際の貨幣を使用していますか？
        </h4>

        <p class="QaTxt">
          勝winでは日本円での入出金に対応しております。
        </p>

        <br><br>

        <h4 class="lanSubtitle">
          Q. 年齢制限はありますか？
        </h4>

        <p class="QaTxt">
          勝winのご利用は20歳以上の方に限定しております。
        </p>

        <br><br>

        <h4 class="lanSubtitle">
          Q. プレイ可能な地域はどこですか？
        </h4>

        <p class="QaTxt">
          コモロ諸島の法律に基づき、以下の国または地域にお住いのお客様は、勝winの口座開設、またはご利用いただくことができません。
        </p>
        <p class="QaTxt">
          オーストラリア、オーストリア、コモロ諸島
          フランス、ドイツ、オランダ、スペイン、英国、米国、すべてのFATFブラックリスト掲載国。
        </p>
      </div>
    </section>

    <section class="lanSection lanContentBox bg-brown-02">
      <div class="lan_title">
        まずは無料で登録！
      </div>

      <div class="lanCardFrame">
        <div class="lanCardBox">
          <div class="lanCardSubTitle">
            初回入金特典
          </div>

          <div class="lanCardContainer">
            <div class="lanCardTitle">
              50%
            </div>
            <div class="lanCardText">
              キャッシュバックボーナス
            </div>
          </div>
        </div>
      </div>

      <div class="lanCardFrame">
        <div class="lanCardBox">
          <div class="lanCardSubTitle">
            新規登録特典
          </div>

          <div class="lanCardContainer">
            <div class="lanCardTitle">
              {{ bonusAmount }}<span class="fs-32px">円分</span>
            </div>
            <div class="lanCardText">
              無料体験ボーナス
            </div>
          </div>
        </div>
      </div>

      <div class="lanBTNFrame">
        <button class="btn btn-primary btn-landing" @click.stop="goHomeRegister">
          今すぐ登録
        </button>
      </div>
    </section>

    <div v-if="isMobile()" id="mobile-btn" class="freeTrial-Frame">
      <button class="btn btn-freeTrial" @click.stop="goHomeRegister(false)">
        <span class="fs-32px firstHalf ">無料体験</span>
        <span class="fs-24px secondHalf">はこちら！</span>
      </button>
    </div>
  </div>
</template>

<script>
import { logout as localLogout } from '@/utils/user'
import dImg from '@/components/dynamicImg'
import { getCategory, getGames } from '@/api/game'
import { mapGetters } from 'vuex'
import { gameStart } from '@/utils/games'
import { detectMob } from '@/utils/tool'

export default {
  name: 'Land2',
  components: {
    dImg
  },
  data() {
    return {
      allGameData: null,
      activeGameId: null,
      cardWidth: 290,
      actualGap: 16,
      bonusAmount: '2000',
      currentPage: 1,
      pageSize: 30,
      totalGames: [],
      hasMoreGames: true
    }
  },
  computed: {
    ...mapGetters(['game', 'brand']),
    gameCategory() {
      const category = Array.isArray(this.$store.getters.gameCategory)
        ? this.$store.getters.gameCategory.slice()
        : []

      return [...category].sort((a, b) => a.sorting - b.sorting)
    },
    brandImage() {
      const brandImage = this.brand.brandImage.img_event
      return Array.isArray(brandImage)
        ? [...brandImage].sort((a, b) => a.sort - b.sort)
        : []
    },
    brandName() {
      return process.env.VUE_APP_BRAND_NAME
    }
  },
  created() {
    const pathMatch = this.$route.path.match(/newlanding(\d+)/)
    if (pathMatch && pathMatch[1]) {
      this.bonusAmount = pathMatch[1]
    }
    if (this.$store.getters.token) {
      localLogout()
    }
    getCategory().then((response) => {
      this.$store.commit('SET_GAME_CATEGORY', response.data.data)
      // After getting categories, load games with the first category
      if (response.data.data && response.data.data.length > 0) {
        const firstCategory = response.data.data.sort((a, b) => a.sorting - b.sorting)[0]
        this.changeGameCategory(firstCategory)
      }
    })
  },
  methods: {
    showSearchGame() {
      this.$router.push('/')
      setTimeout(() => {
        this.$store.commit('SET_SHOW_RESEARCH', true)
        this.$store.commit('SET_SHOW_PROVIDER', false)
      }, 1000)
    },
    showSearchProvider() {
      this.$router.push('/')
      setTimeout(() => {
        this.$store.commit('SET_SHOW_PROVIDER', true)
        this.$store.commit('SET_SHOW_RESEARCH', false)
      }, 1000)
    },
    async changeGameCategory(item) {
      this.currentPage = 1
      const params = {
        category: item.id,
        page: 1,
        page_size: 100
      }
      const response = await getGames(params)
      this.totalGames = response.data.data.list || []
      this.allGameData = this.totalGames.slice(0, this.pageSize)
      this.hasMoreGames = this.allGameData.length < this.totalGames.length
    },
    loadMoreGames() {
      if (!this.totalGames || !this.hasMoreGames) return

      this.currentPage++
      const nextBatch = this.totalGames.slice(0, this.pageSize * this.currentPage)
      this.allGameData = nextBatch
      this.hasMoreGames = this.allGameData.length < this.totalGames.length
    },
    getProviderImage(providerId) {
      const provider = this.game.gameSideBarProvider.find(
        provider => provider.game_provider_id === providerId
      )
      return provider ? provider.image_h5 : ''
    },
    isGameFavorite(gameId) {
      const favorites = this.$store.getters.favoriteGames || []
      return favorites.includes(gameId)
    },
    handleLaunchGame(game) {
      this.$router.push('/')
      setTimeout(() => {
        gameStart('game', game)
      }, 1000)
    },
    goHomeRegister(redirect = true) {
      if (!redirect) {
        this.$store.commit('SET_REGISTER_OPEN', true)
        return
      }

      this.$router.push('/')
      setTimeout(() => {
        this.$store.commit('SET_REGISTER_OPEN', true)
      }, 500)
    },
    handleClick(banner_url, open_type) {
      let id
      const match = banner_url.match(/eventId=(\d+)/)
      if (match && match[1]) {
        id = match[1]
      } else {
        id = banner_url.split('/').pop()
      }

      switch (open_type) {
        case 'self':
          this.$router.push({ path: '/event', query: { eventId: id }})
          break

        case 'iframe':
          this.$store.commit('SET_GAME_URL', banner_url)
          break

        case 'new':
          window.open(banner_url, '_blank')
          break

        default:
          this.$router.push({ path: '/event', query: { eventId: id }})
      }
    },
    isMobile() {
      return detectMob()
    }
  }
}
</script>

